import React from 'react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from 'eco-design-reliance/gtm';
import EcoTitle from 'eco-design/base/eco-title';

const SvgIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="11" viewBox="0 0 18 11" fill="none">
            <path
                d="M2.37345 0.410044C1.83081 -0.136682 0.951179 -0.136682 0.408542 0.410044C-0.134095 0.956771 -0.134095 1.84321 0.408542 2.38994L7.81903 9.85653C8.35692 10.3986 9.22738 10.404 9.77187 9.86867L17.1824 2.58381C17.7317 2.04384 17.7425 1.15749 17.2066 0.604066C16.6707 0.0506379 15.791 0.0397185 15.2417 0.579669L8.81356 6.89886L2.37345 0.410044Z"
                fill="white"
                fill-opacity="0.8"
            />
        </svg>
    );
};

const SectionPicture = ({ linkClick }: any) => {
    const { t } = useLang('Delta3MaxSeriesStation.SectionPicture');

    function handleLink(href: string, className: string) {
        const element = document.getElementById(href.replace('#', ''));
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        if (className === 'item3') {
            linkClick(1);
        }
        gtm.push({
            __btn_id1: `section-bg-wrap .${className}`,
            __btn_id2: className,
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    }

    return (
        <section className={`${styles.SectionPicture} GtmModuleData-section`} data-section-id={'SectionPicture'}>
            <div className="section-bg-wrap">
                <EcoTitle title={t('title')} />

                <div className="sec-content">
                    <div
                        className="item1 item-box"
                        onClick={() => {
                            handleLink('IndustryLeadingD', 'item1-icon');
                        }}
                    >
                        <EcoImg
                            isOpenLazy
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1762223278459/1.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762223278459/1.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762223463487/m-5.jpg"
                            alt=""
                        ></EcoImg>
                        <p className="sub-text">
                            {t.rich('item1', {
                                text1: (v: string) => <span>{v}</span>,
                            })}
                        </p>
                        <div className="link-item item1-icon GtmModuleData-btn-common" data-btn-id="item1-icon">
                            <SvgIcon />
                        </div>
                    </div>
                    <div
                        className="item2 item-box GtmModuleData-btn-common"
                        onClick={() => {
                            handleLink('UsageScenariosC', 'item2-icon');
                        }}
                    >
                        <EcoImg
                            isOpenLazy
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1762223279547/2.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762223279547/2.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762223463810/m-2.jpg"
                            alt=""
                        ></EcoImg>
                        <p className="sub-text">
                            {t.rich('item2', {
                                text1: (v: string) => <span>{v}</span>,
                            })}
                        </p>
                        <div className="link-item item2-icon GtmModuleData-btn-common" data-btn-id="item2-icon">
                            <SvgIcon />
                        </div>
                    </div>
                    <div
                        className="item3 item-box GtmModuleData-btn-common"
                        onClick={() => {
                            handleLink('IndustryLeadingE', 'item3-icon');
                        }}
                    >
                        <EcoImg
                            isOpenLazy
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1762223279021/3.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762223279021/3.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762223461469/m-7.jpg"
                            alt=""
                        ></EcoImg>
                        <p className="sub-text">
                            {t.rich('item3', {
                                text1: (v: string) => <span>{v}</span>,
                            })}
                        </p>
                        <div className="link-item item3-icon GtmModuleData-btn-common" data-btn-id="item3-icon">
                            <SvgIcon />
                        </div>
                    </div>
                    <div
                        className="item4 item-box GtmModuleData-btn-common"
                        onClick={() => {
                            handleLink('UsageScenariosA', 'item4-icon');
                        }}
                    >
                        <EcoImg
                            isOpenLazy
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1762223279270/4.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762223279270/4.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762223461026/m-1.jpg"
                            alt=""
                        ></EcoImg>
                        <p className="sub-text">
                            {t.rich('item4', {
                                text1: (v: string) => <span>{v}</span>,
                            })}
                        </p>
                        <div className="link-item item4-icon GtmModuleData-btn-common" data-btn-id="item4-icon">
                            <SvgIcon />
                        </div>
                    </div>
                    <div
                        className="item5 item-box GtmModuleData-btn-common"
                        onClick={() => {
                            handleLink('IndustryLeadingD', 'item5-icon');
                        }}
                    >
                        <EcoImg
                            isOpenLazy
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1762223279760/5.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762223279760/5.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762223462106/m-4.jpg"
                            alt=""
                        ></EcoImg>
                        <p className="sub-text">
                            {t.rich('item5', {
                                text1: (v: string) => <span>{v}</span>,
                            })}
                        </p>
                        <div className="link-item item5-icon GtmModuleData-btn-common" data-btn-id="item5-icon">
                            <SvgIcon />
                        </div>
                    </div>
                    <div
                        className="item6 item-box GtmModuleData-btn-common"
                        onClick={() => {
                            handleLink('PowerTechnology', 'item6-icon');
                        }}
                    >
                        <EcoImg
                            isOpenLazy
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1762249015229/Frame%201000008977.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762249015229/Frame%201000008977.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762249014950/Frame%20211878.jpg"
                            alt=""
                        ></EcoImg>
                        <p className="sub-text">
                            {t.rich('item6', {
                                text1: (v: string) => <span>{v}</span>,
                            })}
                        </p>
                        <div className="link-item item6-icon GtmModuleData-btn-common" data-btn-id="item6-icon">
                            <SvgIcon />
                        </div>
                    </div>
                    <div
                        className="item7 item-box GtmModuleData-btn-common"
                        onClick={() => {
                            handleLink('UsageScenariosB', 'item7-icon');
                        }}
                    >
                        <EcoImg
                            isOpenLazy
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1762223280016/7.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762223280016/7.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762223463039/m-3.jpg"
                            alt=""
                        ></EcoImg>
                        <p className="sub-text">
                            {t.rich('item7', {
                                text1: (v: string) => <span>{v}</span>,
                            })}
                        </p>
                        <div className="link-item item7-icon GtmModuleData-btn-common" data-btn-id="item7-icon">
                            <SvgIcon />
                        </div>
                    </div>
                    <div
                        className="item8 item-box GtmModuleData-btn-common"
                        onClick={() => {
                            handleLink('PowerTechnology', 'item8-icon');
                        }}
                    >
                        <EcoImg
                            isOpenLazy
                            className="item-img"
                            pc="https://websiteoss.ecoflow.com/upload/image/1762223278631/8.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1762223278631/8.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1762223461779/m-8.jpg"
                            alt=""
                        ></EcoImg>
                        <p className="sub-text">
                            {t.rich('item8', {
                                text1: (v: string) => <span>{v}</span>,
                            })}
                        </p>
                        <div className="link-item item8-icon GtmModuleData-btn-common" data-btn-id="item8-icon">
                            <SvgIcon />
                        </div>
                    </div>
                </div>
                <div className="tips-content">
                    <p>{t('tip1')}</p>
                    <p>{t('tip2')}</p>
                    <p>{t('tip3')}</p>
                </div>
            </div>
        </section>
    );
};

export default SectionPicture;
